import { useEffect, useState } from 'react';
import { useRecoilState } from 'recoil';

import { navigationService } from '@services';
import { hdmiConnectedState, screenReaderEnabledState } from '@store';

import Manifest from '../../manifest.json';
import { DebugMenuIDs } from '../components/debug/DebugMenuIDs';
import { isWeb } from '../helpers/Platform';

const shortcut = 'UULRL';

export const useDebugTrigger = () => {
  const [lastInput, setInput] = useState('');

  const useTVEventHandler = require('react-native').useTVEventHandler || (() => null);

  const [hdmiConnected, setHdmiConnected] = useRecoilState(hdmiConnectedState);
  const [screenReaderEnabled, setScreenReaderEnabled] = useRecoilState(screenReaderEnabledState);

  const inputHandler = event => {
    const isDevelopment = __DEV__ || Manifest.debug;

    if (!isDevelopment) {
      return;
    }

    if ((event?.eventKeyAction ?? 0) !== 0) {
      return;
    }

    if (event?.eventType) {
      event.key = event.eventType;
    }

    if (event?.key) {
      let nextInput = '';

      switch (event.key) {
        case 'ArrowLeft':
        case 'left':
          nextInput = 'L';
          break;
        case 'ArrowRight':
        case 'right':
          nextInput = 'R';
          break;
        case 'ArrowUp':
        case 'up':
          nextInput = 'U';
          break;
        case 'ArrowDown':
        case 'down':
          nextInput = 'D';
          break;
        case 'q':
          setHdmiConnected(!hdmiConnected);
          break;
        case 's':
          setScreenReaderEnabled(!screenReaderEnabled);
          break;
        default:
          break;
      }

      if (nextInput !== '') {
        const newInput = `${lastInput.slice(-(shortcut.length - 1))}${nextInput}`;

        if (newInput === shortcut) {
          setInput('');
          navigationService.navigate(DebugMenuIDs.debugMenuPage);
        } else {
          setInput(newInput);
        }
      }
    }
  };

  useTVEventHandler(inputHandler);

  useEffect(() => {
    isWeb && document.addEventListener('keydown', inputHandler);
    return () => {
      isWeb && document.removeEventListener('keydown', inputHandler);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lastInput, hdmiConnected, screenReaderEnabled]);
};
